export default __webpack_public_path__ + "static/media/new-truck-nav-completed.aa562cef.svg";